import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';

export const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-pink-50">
      {/* Header */}
      <div className="bg-white shadow-sm sticky top-0 z-10">
        <div className="container mx-auto px-6 py-4">
          <Button
            onClick={() => window.location.href = '/'}
            variant="ghost"
            className="text-[#eb068c] hover:text-[#c7056f]"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Voltar para Home
          </Button>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 py-12 max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          Política de Privacidade
        </h1>
        <p className="text-gray-600 mb-8">
          Última atualização: {new Date().toLocaleDateString('pt-BR')}
        </p>

        <div className="bg-white rounded-xl shadow-sm p-8 space-y-8">
          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Introdução</h2>
            <p className="text-gray-700 leading-relaxed">
              A <strong>Plantinha de Geladeira</strong> respeita a privacidade de todos os visitantes e clientes. 
              Esta Política de Privacidade descreve como coletamos, usamos e protegemos suas informações pessoais 
              quando você utiliza nosso site ou serviços B2B.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Informações que Coletamos</h2>
            <p className="text-gray-700 leading-relaxed mb-3">
              Podemos coletar as seguintes informações:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Nome, razão social e CNPJ (para clientes B2B)</li>
              <li>Endereço de e-mail e telefone de contato</li>
              <li>Informações de navegação (cookies, endereço IP, páginas visitadas)</li>
              <li>Dados fornecidos voluntariamente em formulários ou via WhatsApp</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Como Usamos Suas Informações</h2>
            <p className="text-gray-700 leading-relaxed mb-3">
              As informações coletadas são utilizadas para:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Processar e responder suas solicitações de orçamento</li>
              <li>Enviar comunicações comerciais e promocionais (mediante consentimento)</li>
              <li>Melhorar nossos produtos, serviços e experiência do usuário</li>
              <li>Cumprir obrigações legais e regulatórias</li>
              <li>Realizar análises estatísticas e de marketing</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Compartilhamento de Informações</h2>
            <p className="text-gray-700 leading-relaxed">
              Não vendemos, alugamos ou comercializamos suas informações pessoais. 
              Podemos compartilhar dados apenas com:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4 mt-3">
              <li>Parceiros logísticos para entrega de produtos</li>
              <li>Prestadores de serviços que nos auxiliam nas operações</li>
              <li>Autoridades legais, quando exigido por lei</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Cookies e Tecnologias Similares</h2>
            <p className="text-gray-700 leading-relaxed">
              Utilizamos cookies e tecnologias similares para melhorar sua experiência de navegação, 
              realizar análises e personalizar conteúdo. Você pode gerenciar suas preferências de cookies 
              através das configurações do seu navegador.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Segurança dos Dados</h2>
            <p className="text-gray-700 leading-relaxed">
              Implementamos medidas técnicas e organizacionais adequadas para proteger suas informações 
              contra acesso não autorizado, alteração, divulgação ou destruição. No entanto, nenhum método 
              de transmissão pela internet é 100% seguro.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Seus Direitos (LGPD)</h2>
            <p className="text-gray-700 leading-relaxed mb-3">
              De acordo com a Lei Geral de Proteção de Dados (LGPD), você tem direito a:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 ml-4">
              <li>Confirmar a existência de tratamento de dados pessoais</li>
              <li>Acessar seus dados pessoais</li>
              <li>Corrigir dados incompletos, inexatos ou desatualizados</li>
              <li>Solicitar a anonimização, bloqueio ou eliminação de dados</li>
              <li>Revogar o consentimento a qualquer momento</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Contato</h2>
            <p className="text-gray-700 leading-relaxed">
              Para exercer seus direitos ou esclarecer dúvidas sobre esta Política de Privacidade, 
              entre em contato conosco:
            </p>
            <div className="mt-4 p-4 bg-pink-50 rounded-lg">
              <p className="text-gray-700"><strong>E-mail:</strong> b2b@plantinhadegeladeira.com.br</p>
              <p className="text-gray-700"><strong>WhatsApp:</strong> (11) 94165-1849</p>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Alterações nesta Política</h2>
            <p className="text-gray-700 leading-relaxed">
              Podemos atualizar esta Política de Privacidade periodicamente. Recomendamos que você 
              revise esta página regularmente para se manter informado sobre como protegemos suas informações.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};
